<template>
  <div class="ui-stepper"
       :class="[disabled ? 'disabled' : '']">
    <icon class="ui-stepper__act-btn"
          :src="iconReduce"
          :class="leftDisabled ? 'disabled' : ''"
          @click="handleReduce"></icon>
    <span class="ui-stepper__num">{{ value }}</span>
    <icon class="ui-stepper__act-btn"
          :class="rightDisabled ? 'disabled' : ''"
          :src="iconAdd"
          @click="handleAdd"></icon>
  </div>
</template>

<script>
/*
 * http://lanhu.nioint.com/web/#/item/project/board?from=nav&pid=f651cd6a-e368-4d69-88da-a0dd8641d453
 * 步进器
 */
import Icon from '@/components/ui/Icon';
import addIcon from '@/assets/images/icon/icon_stepper_add_36.png';
import reduceIcon from '@/assets/images/icon/icon_stepper_reduce_36.png';
import addDIcon from '@/assets/images/icon/icon_stepper_add_36_disable.png';
import reduceDIcon from '@/assets/images/icon/icon_stepper_reduce_36_disable.png';

export default {
  name: 'Stepper',
  components: {
    Icon
  },
  props: {
    value: {
      type: [Number, String],
      default: 1
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      iconAdd: addIcon,
      iconReduce: reduceIcon,
      leftDisabled: false,
      rightDisabled: false
    };
  },
  watch: {
    value(val){
      this.iconReduce = val <= this.min ? reduceDIcon : reduceIcon;
      this.iconAdd = val >= this.max ? addDIcon : addIcon;
      this.leftDisabled = val <= this.min;
      this.rightDisabled = val >= this.max;
    },
    max(val){
      if (this.value > val){
        this.$emit('input', val);
      }
      this.setIconStatus();
    },
    min(val){
      if (this.value < val){
        this.$emit('input', val);
      }
      this.setIconStatus();
    }
  },
  mounted(){
    this.setIconStatus();
  },
  methods: {
    handleReduce(){
      if (this.disabled){
        return;
      }
      let newValue = this.value - 1;

      if (this.min && newValue < this.min){
        return;
      }
      this.$emit('input', newValue);
    },
    handleAdd(){
      if (this.disabled){
        return;
      }
      let newValue = this.value + 1;

      if (this.max && newValue > this.max){
        return;
      }
      this.$emit('input', newValue);
    },
    setIconStatus(){
      this.iconAdd = this.max <= this.value || this.disabled ? addDIcon : addIcon;
      this.iconReduce = this.min >= this.value || this.disabled ? reduceDIcon : reduceIcon;
      this.rightDisabled = this.max <= this.value || this.disabled;
      this.leftDisabled = this.min >= this.value || this.disabled;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/standard";

.ui-stepper {
  display: flex;
  align-items: center;

  &.disabled {
    pointer-events: none;
  }

  &__num {
    min-width: sizeTrans(50);
    padding: 0 sizeTrans($space_10);
    @include font_h2_s();
    text-align: center;
  }

  &__act-btn {
    width: sizeTrans(36);
    height: sizeTrans(36);
    border-radius: 50%;
    cursor: pointer;
    &.disabled {
      cursor: not-allowed;
    }
  }
}
</style>